import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/banner-img-1.jpg'
import _imports_1 from '@/assets/images/banner-img-3.jpg'
import _imports_2 from '@/assets/images/banner-img-2.jpg'
import _imports_3 from '@/assets/images/banner-img-4.jpg'
import _imports_4 from '@/assets/images/shape-1.png'


const _hoisted_1 = { class: "banner-area bg-black overflow-hidden position-relative z-1" }
const _hoisted_2 = { class: "container mw-1780" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-5" }
const _hoisted_5 = {
  class: "banner-content",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "100"
}
const _hoisted_6 = { class: "banner-btn d-flex align-items-center justify-content-md-center justify-content-lg-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("h1", null, "أقوى وأسرع اشتراك IPTV في ألمانيا وأوروبا للمنزل والأعمال", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("p", null, " من الملاعب العالمية وحتى شاشتك مباشرة، استمتع بأقوى تجربة مشاهدة بدون تقطيع. نوفر لك كافة القنوات العربية والعالمية المفضلة لديك بثبات تام. ", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("h6", null, " احصل على سيرفر ثابت بجودة 4K — ابتداءً من 30 يورو سنوياً، بدون عقود التزام ", -1)),
            _createElementVNode("div", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("a", {
                href: "https://wa.me/447429916178",
                target: "_blank",
                class: "btn"
              }, [
                _createElementVNode("span", { class: "border-style" }, "اشترك الآن")
              ], -1)),
              _createVNode(_component_RouterLink, {
                to: "/pricing-plan",
                class: "read-more"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode(" عرض باقات الأسعار والتفاصيل ", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ]),
        _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"col-lg-7\"><div class=\"banner-img-wrap text-start\"><div class=\"row g-0\"><div class=\"col-lg-6 col-sm-6\" data-aos=\"fade-up\" data-aos-duration=\"1000\" data-aos-delay=\"200\"><div class=\"banner-img banner-img-one\"><img src=\"" + _imports_0 + "\" alt=\"banner-img\"></div><div class=\"banner-img banner-img-two\"><img src=\"" + _imports_1 + "\" alt=\"banner-img\"></div></div><div class=\"col-lg-6 col-sm-6\" data-aos=\"fade-up\" data-aos-duration=\"1000\" data-aos-delay=\"300\"><div class=\"banner-img banner-img-three\"><img src=\"" + _imports_2 + "\" alt=\"banner-img\"></div><div class=\"banner-img banner-img-four\"><img src=\"" + _imports_3 + "\" alt=\"banner-img\"></div></div></div></div></div>", 1))
      ])
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("img", {
      src: _imports_4,
      class: "shape shape-1",
      alt: "shape"
    }, null, -1))
  ]))
}